<template>
  <div>
    <vue-element-loading
      is-full-screen
      :active="loading"
      spinner="bar-fade-scale"
      color="#152d51"
    />
    <div class="px-5">
      <div v-if="optionNcap && optionNcap.length">
        <div class="mb-2 flex-all-center">
          <div>
            <v-img
              class="my-0 radius-circle"
              style="width:170px;height:auto"
              src="@/assets/logo_long.png"
            ></v-img>
          </div>
        </div>
        <div class="text-gray">กรุณาระบุสัญญา</div>
        <v-select
          v-model="selectContact"
          @change="handleSelectContact"
          class="mt-5"
          :items="optionNcap"
          label="เลือกสัญญา"
          dense
          outlined
        ></v-select>
      </div>
      <div v-if="optionNmny && optionNmny.length">
        <div class="mb-2 flex-all-center">
          <div>
            <v-img
              class="my-0 radius-circle"
              style="width:170px;height:auto"
              src="@/assets/logo_long_nm.png"
            ></v-img>
          </div>
        </div>
        <div class="text-gray">กรุณาระบุสัญญา</div>
        <v-select
          v-model="selectContact"
          @change="handleSelectContact"
          class="mt-5"
          :items="optionNmny"
          label="เลือกสัญญา"
          dense
          outlined
        ></v-select>
      </div>
      <div
        class="mb-5 mt-10 w-100 flex-all-center"
        v-if="optionNcap.length > 0 || optionNmny.length > 0"
      >
        <v-btn
          @click="clickShow"
          large
          class="main-btn"
          style="color:white;min-width:50vw"
          color="#23409A"
          >ถัดไป</v-btn
        >
      </div>
    </div>
    <div
      v-if="!optionNcap.length && !optionNmny.length"
      style="display: flex; justify-content: center; align-items: center; flex-direction: column;"
    >
      <div class="mb-2 flex-all-center">
        <div>
          <v-img
            class="my-0 radius-circle"
            style="width: 170px; height: auto"
            src="@/assets/logo_long.png"
          ></v-img>
        </div>
        <div>
          <v-img
            class="my-0 radius-circle"
            style="width: 170px; height: auto"
            src="@/assets/logo_long_nm.png"
          ></v-img>
        </div>
      </div>
      <div class="text-center mb-8">
        ไม่มีสัญญาที่อยู่ระหว่างการรอชำระ
      </div>
      <v-btn
        :loading="loading"
        @click="backtoChat"
        class="main-btn col-8"
        style="color: white"
        color="#23409a"
      >
        กลับสู่แชท
      </v-btn>
    </div>
    <v-dialog v-model="show" scrollable max-width="500px" transition="dialog-transition">
      <v-card v-if="typeGen == 'qr' && barCodeData && useAbleRefCode" class="p-3">
        <div class="text-right">
          <v-btn icon @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="text-center" style="margin-top:-25px">
          ยอดชำระ
          <span class="text-blue fs-18" :style="`color: ${color} !important`">{{
            formatNumber(contact.paymentDue)
          }}</span>
          บาท
        </div>
        <div class="flex-all-center">
          <VueQrcode ref="qrref" @ready="cBit" :value="useAbleRefCode" :width="250" />
        </div>
        <v-img class="mr-2" :src="bit"></v-img>
        <div class=" text-center">
          <div class="text-blue" :style="`color: ${color} !important`">
            แคปเจอร์หน้าจอเพื่อบันทึกภาพ
          </div>
          <div class="text-center">
            <span class="text-blue" :style="`color: ${color} !important`">ผู้เช่าซื้อ</span> :
            {{ barCodeData.prefix }}{{ barCodeData.firstName }} {{ barCodeData.lastName }}
          </div>
          <!-- <v-btn @click="downloadQR" large class="px-7 main-btn my-3" style="color:white" color="#23409A"
            ><span><v-img class="mr-2" style="width:20px;height:auto" src="@/assets/dist.svg"></v-img></span> บันทึกภาพ
          </v-btn> -->
        </div>
      </v-card>
      <v-card
        v-else-if="typeGen == 'bar' && barCodeData && useAbleRefCode"
        class="p-3"
        style="height:90vh"
      >
        <div class="text-right">
          <v-btn icon @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="text-center" style="margin-top:-25px">
          ยอดชำระ
          <span class="text-blue fs-18" :style="`color: ${color} !important`">{{
            formatNumber(contact.paymentDue)
          }}</span>
          บาท
        </div>
        <div
          style="width:0;heigth:0;transform: rotate(90deg);margin-left: 140px;margin-top: -45px;"
        >
          <VueBarcode
            ref="barref"
            :text="barCodeData.refCardDisplay"
            :value="useAbleRefCode"
            elementTag="img"
          />
        </div>
        <div class="bot-session text-center">
          <div class="text-blue" :style="`color: ${color} !important`">
            แคปเจอร์หน้าจอเพื่อบันทึกภาพ
          </div>
          <div class="text-center">
            <span class="text-blue" :style="`color: ${color} !important`">ผู้เช่าซื้อ</span> :
            {{ barCodeData.prefix }}{{ barCodeData.firstName }} {{ barCodeData.lastName }}
          </div>
          <!-- <v-btn @click="downloadBar" large class="px-7 main-btn my-3" style="color:white" color="#23409A"
            ><span><v-img class="mr-2" style="width:20px;height:auto" src="@/assets/dist.svg"></v-img></span> บันทึกภาพ
          </v-btn> -->
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import api from '@/api'
import contractApi from '@/api/contract'
import config from '@/config'
import moment from 'moment'
import VueQrcode from 'vue-qrcode'
import VueBarcode from 'vue-barcode'
import { formatThaiDate } from '@/utils/dateFormat'
export default {
  components: { VueElementLoading, VueQrcode, VueBarcode },
  props: {
    userData: {
      default: {}
    }
  },
  data() {
    return {
      loading: false,
      selectContact: '',
      ncapContactList: [],
      nmnyContactList: [],
      barCodeData: null,
      contact: null,
      show: false,
      bit: null,
      useAbleRefCode: null,
      source: 'ncap',
      selectContactdata: null
    }
  },
  watch: {
    userData: {
      immediate: true,
      deep: true,
      handler(userData) {
        if (userData && userData.cardnumber) {
          this.setup()
        }
      }
    }
  },
  mounted() {
    // this.setup();
  },
  methods: {
    async setup() {
      this.loading = true
      await this.fetchContact()
      this.loading = false
    },
    cBit(val) {
      this.bit = val
    },
    formatNumber(num) {
      let temp_num = parseFloat(num).toFixed(2)
      let pattern = /\d{1,3}(?=(\d{3})+(?!\d))/g
      return temp_num.toString().replace(pattern, '$&,')
    },
    async clickShow() {
      if (this.source && this.source == 'nmny') {
        this.clickShowNmny()
        return
      }
      this.$store.dispatch('setContactSource', 'ncap')

      if (this.typeGen) {
        this.loading = true
        this.contact = this.selectContactdata
        let body = {
          id_card: this.userData.cardnumber,
          agreement_no: this.contact.agreementNo,
          page_id: config.pageid,
          company: 'NCAP'
        }
        let res = await contractApi.genBarCode({ body })

        this.barCodeData = res?.data?.data
        this.show = true
        let split_data = this.barCodeData.refCard.substring(1)
        if (this.typeGen == 'bar') {
          split_data = split_data.replace('|00|', '||')
          split_data = `${split_data.split('||')[0]}||00`
        }
        split_data = `|${split_data.replaceAll('|', '\n')}`
        this.useAbleRefCode = split_data
        this.loading = false
      } else {
        this.loading = true
        this.$store.dispatch('setContact', this.selectContactdata)
        this.$store.dispatch('setUserData', this.userData)
        this.$router.push('/paymentgenerate')
        this.loading = false
      }
    },
    async clickShowNmny() {
      this.$store.dispatch('setContactSource', 'nmny')
      if (this.typeGen) {
        this.loading = true

        this.contact = this.selectContactdata
        let body = {
          id_card: this.userData.cardnumber,
          agreement_no: this.contact.agreementNo,
          page_id: config.pageid,
          company: 'NMNY'
        }
        let res = await contractApi.genBarCode({ body })

        this.barCodeData = res?.data?.data
        this.show = true
        let split_data = this.barCodeData.refCard.substring(1)
        split_data = `|${split_data.replaceAll('|', '\n')}`
        this.useAbleRefCode = split_data
        this.loading = false
      } else {
        this.loading = true
        this.$store.dispatch('setContact', this.selectContactdata)
        this.$store.dispatch('setUserData', this.userData)
        this.$router.push('/paymentgenerate')
        this.loading = false
      }
    },
    async fetchContact() {
      this.loading = true
      try {
        const configApi = {
          body: {
            page_id: config.pageid,
            id_card: this.userData.cardnumber || this.userDataCom.cardnumber,
            birth_day: formatThaiDate(this.userData.dob)
          },
          config: {}
        }
        const response = await contractApi.getLoanInfo(configApi)
        this.ncapContactList = response?.data?.data?.ncapLoanInfoList
        this.nmnyContactList = response?.data?.data?.nmnyLoanInfoList
        const ncapContactLength = this.ncapContactList.length || 0
        const nmnyContactLength = this.nmnyContactList.length || 0
        const totalContact = ncapContactLength + nmnyContactLength
        if (totalContact <= 1) {
          if (this.ncapContactList.length === 1) {
            this.selectContact = `เลขที่สัญญา ${this.ncapContactList[0].agreementNo}`
            this.handleSelectContact()
            this.clickShow()
          } else if (this.nmnyContactList.length === 1) {
            this.selectContact = `เลขที่สัญญา ${this.nmnyContactList[0].agreementNo}`
            this.handleSelectContact()
            this.clickShow()
          }
        }
      } catch (error) {
        console.error(error)
        this.$swal.fire({
          type: 'error',
          text: 'เรียกข้อมูลไม่สำเร็จ'
        })
      } finally {
        this.loading = false
      }
    },
    handleSelectContact() {
      if (this.selectContact) {
        this.source = 'ncap'
        let id = this.selectContact.split(' ')
        id = id[1]
        let data = this.ncapContactList.find(ele => ele.agreementNo == id)
        console.log(1, this.source)
        if (!data) {
          console.log(2, this.source)
          this.source = 'nmny'
          console.log(3, this.source)
          data = this.nmnyContactList.find(ele => ele.agreementNo == id)
        }

        this.selectContactdata = data
      } else {
        this.selectContactdata = null
      }
    },
    downloadQR() {
      let img = this.$refs.qrref.$el.src
      var link = document.createElement('a')
      link.download = 'QR.png'
      link.href = img
      document.body.appendChild(link)
      link.click()
    },
    downloadBar() {
      let img = this.$refs.barref.$el.getElementsByClassName('vue-barcode-element')[0].src
      var link = document.createElement('a')
      link.download = 'QR.png'
      link.href = img
      document.body.appendChild(link)
      link.click()
    },
    backtoChat() {
      this.$liff.closeWindow()
    }
  },
  computed: {
    query() {
      return this.$store.state.query
    },
    view() {
      return this.$store.state.query.view
    },
    profile() {
      return this.$store.state.profile
    },
    typeGen() {
      return this.$store.state.query.type ? this.$store.state.query.type : null
    },
    userDataCom() {
      return this.$store.state.userData ? this.$store.state.userData : null
    },
    // userId() {
    //   return this.$store.state.profile.userId;
    // },
    optionNcap() {
      let data = []
      this.ncapContactList.forEach(ele => {
        data.push(`เลขที่สัญญา ${ele.agreementNo}`)
      })
      return data
    },
    optionNmny() {
      let data = []
      this.nmnyContactList.forEach(ele => {
        data.push(`เลขที่สัญญา ${ele.agreementNo}`)
      })
      return data
    },
    color() {
      if (this.source == 'nmny') {
        return '#007a47'
      }
      return '#23409a'
    }
  }
}
</script>

<style></style>
